module.exports = "/assets/data/9038f5d378fb8821e5895a273deb55e3-WN1.data.json";